import { Navigation } from "@/components/Navigation";
import { HomeHero } from "@/components/home/HomeHero";
import { HomeServices } from "@/components/home/HomeServices";
import { HomeWhySimNet } from "@/components/home/HomeWhySimNet";
import { HomeIndustries } from "@/components/home/HomeIndustries";
import { HomeCoverage } from "@/components/home/HomeCoverage";
import { HomeCTA } from "@/components/home/HomeCTA";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { getPageSEO } from "@/data/seoData";
import { SchemaMarkup } from "@/components/SchemaMarkup";
import { generateOrganizationSchema } from "@/utils/schemaHelpers";

const Index = () => {
  const schemas = [
    generateOrganizationSchema(),
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "SimNet Wireless",
      "url": "https://simnetwireless.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://simnetwireless.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  ];

  return (
    <div className="min-h-screen">
      <SEOHead seo={getPageSEO('home')} path="/" />
      <SchemaMarkup schema={schemas} />
      <Navigation />
      <HomeHero />
      <HomeServices />
      <HomeWhySimNet />
      <HomeIndustries />
      <HomeCoverage />
      <HomeCTA />
      <Footer />
    </div>
  );
};

export default Index;
